import React from "react";
import FieldsTable from "./FieldsTable";

export const FieldsPage: React.FC = () => {
  return <FieldsTable updateTimestamp={1} />;
};
